/* eslint no-template-curly-in-string: "off" */
import { PAYMENT_NETWORKS, FLOW_TYPES } from "../../utils/enums";

const paypalLogo = require("../../assets/images/logo-paypal.png");
const paypalCompleteImg = require("../../assets/images/paypal-confirm.png");

export const tremendousPayPal = {
  id: PAYMENT_NETWORKS.PAYPAL_TREMENDOUS,
  displayName: "PayPal",
  paymentFlow: "email",
  cssClassPrefix: "paypal",
  themeColor: "#009cde",
  paywall: {
    tile: {
      displayName: ["PayPal"],
      tagline: ["Immediately available funds"],
      description: [
        {
          string: "Direct deposit into your validated PayPal account",
          type: "div",
        },
      ],
      logo: paypalLogo,
      // btnLabel: "Next"
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparing your PayPal payment"
    }
  },
  acceptPayment: {
    imgSrc: paypalCompleteImg,
  },
  networkSelectionAccepted: {
    imgSrc: paypalCompleteImg,
    secondaryText: [
      "Upon receipt, you may visit ",
      {
        string: '<a style="font-weight: normal;" href="https://www.paypal.com/myaccount">paypal.com/myaccount</a>',
      },
      " to view your updated balance. A confirmation will be ",
      {
        string: "${payment.recipientNotificationPreference}",
        transformations: [
          {
            type: 'formatPaymentNetworkRecipientType',
          }
        ],
      },
      {
        string: "${payment.recipientNotificationPreference}",
        transformations: [
          {
            type: 'formatEmailAddressOrMobilePhoneNumber',
          },
        ],
        props: {
          className: 'payment-recipientEmail'
        }
      },

    ]
  },
  paymentComplete: {
    initial: {
      secondaryText: [
        "A confirmation email will be sent to ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          }
        },
        ". Please allow a few minutes for your account to update."
      ]
    },
    imgSrc: paypalCompleteImg,
    buttonContainerProps: {
      vertical: true,
    },
    actions: [
      {
        type: "Button",
        props: {
          label: "Shop Now at PayPal",
          href: "https://www.paypal-gifts.com/"
        }
      },
      {
        type: "Button",
        props: {
          label: "View PayPal Balance",
          inverted: true,
          href: "https://www.paypal.com/myaccount/home"
        }
      }
    ],
    affiliateLink: "https://www.paypal.com",
    createAccountLink: "https://www.paypal.com/signup/accountCreate",
    forgotAccountLink:
      "https://www.paypal.com/webapps/accountrecovery/passwordrecovery"
  },
  onHold: {
    imgSrc: paypalCompleteImg,
  }
};

export default tremendousPayPal;
